import api from './api';

const reportService = {
  async getAll(projectCode = null) {
    const params = projectCode ? { projectCode } : {};
    const response = await api.get('/report', { params });
    return response.data;
  },

  async getPaged(page = 1, pageSize = 25, projectCode = null) {
    const params = { page, pageSize };
    if (projectCode) params.projectCode = projectCode;
    const response = await api.get('/report/paged', { params });
    const body = response.data;
    return { data: body.data || [], pagination: body.pagination || {} };
  },

  async getById(id) {
    const response = await api.get(`/report/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/report/create', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.post(`/report/${id}`, data);
    return response.data;
  },

  async submit(id) {
    const response = await api.post(`/report/${id}/submit`);
    return response.data;
  },

  async review(id, data) {
    const response = await api.post(`/report/${id}/review`, data);
    return response.data;
  },

  async approve(id) {
    const response = await api.post(`/report/${id}/approve`);
    return response.data;
  },

  async reject(id, reason) {
    const response = await api.post(`/report/${id}/reject`, { reason });
    return response.data;
  },
};

export default reportService;